import { QRCodeSVG } from "qrcode.react";

import { MFASend } from "pwapi";

import {
  mfaMethodSelectionFormProps,
  useMfaMethodSelectionForm,
} from "shared/hooks/mfaHooks";

import MFACodeInput from "ui/components/MFACodeInput";
import Spinner from "ui/components/Spinner";

const MfaMethodSelectionForm = ({
  required,
  onCancel,
  onConfirm,
}: mfaMethodSelectionFormProps) => {
  const {
    mfaMethod,
    authErrors,
    mfaAppUri,
    currentMfaMethod,
    hasEmail,
    hasPhone,
    code,
    handleSetMfaMethod,
    canResend,
    onChangeCode,
    mfaMethodSentByText,
  } = useMfaMethodSelectionForm({ onConfirm });

  return (
    <div className="MfaMethodSelectionForm">
      <form>
        {!mfaMethod ? (
          <>
            {required && (
              <em className="mfa-prefix">
                You must pick an authentication method to proceed:
              </em>
            )}

            <div className="mfa-method-buttons">
              <div>
                <button
                  className="Button Button--purple"
                  type="button"
                  onClick={() => handleSetMfaMethod(MFASend.mfa_method.EMAIL)}
                  disabled={
                    currentMfaMethod === MFASend.mfa_method.EMAIL || !hasEmail
                  }
                >
                  Email
                </button>

                {currentMfaMethod === MFASend.mfa_method.EMAIL && (
                  <em>
                    <small>CURRENT</small>
                  </em>
                )}
                {!hasEmail && (
                  <em>
                    <small>MISSING</small>
                  </em>
                )}
              </div>
              <div>
                <button
                  className="Button Button--purple"
                  type="button"
                  onClick={() => handleSetMfaMethod(MFASend.mfa_method.SMS)}
                  disabled={
                    currentMfaMethod === MFASend.mfa_method.SMS || !hasPhone
                  }
                >
                  SMS
                </button>

                {currentMfaMethod === MFASend.mfa_method.SMS && (
                  <em>
                    <small>CURRENT</small>
                  </em>
                )}
                {!hasPhone && (
                  <em>
                    <small>MISSING</small>
                  </em>
                )}
              </div>
              <div>
                <button
                  className="Button Button--purple"
                  type="button"
                  onClick={() => handleSetMfaMethod(MFASend.mfa_method.APP)}
                  disabled={currentMfaMethod === MFASend.mfa_method.APP}
                >
                  Authenticator App
                </button>

                {currentMfaMethod === MFASend.mfa_method.APP && (
                  <em>
                    <small>CURRENT</small>
                  </em>
                )}
              </div>
            </div>
            <div className="mfa-buttons">
              <button type="button" className="Button--text" onClick={onCancel}>
                CANCEL
              </button>
            </div>
          </>
        ) : (
          <>
            {authErrors && authErrors.detail && (
              <div className="alert alert-danger">{authErrors.detail}</div>
            )}

            {["email", "sms"].includes(mfaMethod) ? (
              <em className="mfa-prefix">
                Enter the authentication code {mfaMethodSentByText[mfaMethod]}
              </em>
            ) : (
              <>
                <div className="mfa-app-qr">
                  {mfaAppUri ? <QRCodeSVG value={mfaAppUri} /> : <Spinner />}
                </div>
                <em className="mfa-prefix">
                  Scan this QR Code with your Authenticator App and enter the
                  code
                </em>
              </>
            )}

            <MFACodeInput onChange={onChangeCode} value={code} />

            <div className="mfa-form-buttons">
              <button type="button" className="Button--text" onClick={onCancel}>
                CANCEL
              </button>
              {mfaMethod !== "app" && (
                <button
                  type="button"
                  className="Button--text"
                  onClick={() => handleSetMfaMethod(mfaMethod)}
                  disabled={!canResend}
                >
                  RESEND
                </button>
              )}
            </div>

            <div className="mfa-buttons">
              <button
                type="button"
                className="Button--text"
                onClick={() => handleSetMfaMethod(null)}
              >
                Change Authentication Method
              </button>
            </div>
          </>
        )}
      </form>
    </div>
  );
};

export default MfaMethodSelectionForm;
